// extracted by mini-css-extract-plugin
module.exports = {"link":"mqsOB","image":"szKrs","root":"sx0JO"};